const BILLING_PROVIDERS = {
  OLD: 'vindicia',
  NEW: 'recurly',
};

export default BILLING_PROVIDERS;
